import * as React from 'react';
import { cn } from '@/lib/utils';
import iconUrl from '@/assets/brand/zafroi_logo.png';

interface Props {
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  icon?: React.ComponentType<{ className?: string }>;
  className?: string;
}

export function EmptyState({ title, description, action, icon: Icon, className }: Props) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card/50 px-6 py-14 text-center',
        className,
      )}
    >
      {Icon ? (
        <div className="mb-4 grid h-11 w-11 place-items-center rounded-lg bg-muted text-muted-foreground">
          <Icon className="h-5 w-5" />
        </div>
      ) : (
        <img
          src={iconUrl}
          alt=""
          aria-hidden="true"
          className="mb-4 h-12 w-12 opacity-50 grayscale-[20%]"
          draggable={false}
        />
      )}
      <h3 className="text-base font-semibold text-foreground">{title}</h3>
      {description && (
        <p className="mt-1 max-w-md text-sm text-muted-foreground">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
